import { addStyles } from './index.es.js';

var black = "mcbf9b9729_black";
var shadowed = "mcbf9b9729_shadowed";
var styles = ".mcbf9b9729_black{color:#fff}.mcbf9b9729_black:after{background-color:#3e3939}.mcbf9b9729_black:active:after,.mcbf9b9729_black:focus:after,.mcbf9b9729_black:hover:after{background-color:#232121}.mcbf9b9729_black:focus:before{border-color:#232121}.mcbf9b9729_shadowed:after{box-shadow:0 4px 4px rgba(0,0,0,.24)}.mcbf9b9729_shadowed:focus:after,.mcbf9b9729_shadowed:hover:after{box-shadow:0 6px 8px rgba(0,0,0,.24)}.mcbf9b9729_shadowed:active:after{box-shadow:0 2px 2px rgba(0,0,0,.48)}";

addStyles([{
  attributeName: 'theme',
  attributeValue: 'black',
  className: black,
  styles: styles,
  variations: {
    shadowed: shadowed
  }
}]);
